<script>
  import Router from "svelte-spa-router";
  import { routes } from "./lib/router.js";
  import { isLoading } from "./lib/stores/auth.svelte.js";
  import { isLoaded } from "./lib/i18n.svelte.js";
  import Toast from "./components/Toast.svelte";

  let ready = $derived(!isLoading() && isLoaded());
</script>

{#if !ready}
  <div class="min-h-screen w-full bg-black flex items-center justify-center">
    <div class="animate-pulse text-zinc-500 text-sm">Loading...</div>
  </div>
{:else}
  <Router {routes} />
{/if}

<Toast />
